import { useEffect, useState } from "react";
import Draggable from "react-draggable";
import { Box } from "@chakra-ui/layout";
import { COMMON_WEB_PATH, WEB_LAYOUT } from "../../../constant";
import useDeviceType from "../../../hook/useDeviceType";
import { IoIosArrowForward } from "react-icons/io";

const PCToolTab = ({ hiddenHeader, setHiddenHeader }) => {
  const [dragStartTime, setDragStartTime] = useState(0);

  const handleStart = () => {
    setDragStartTime(Date.now());
  };

  const handleStop = () => {
    if (Date.now() - dragStartTime < 200) {
      setHiddenHeader(false);
    }
  };

  return (
    hiddenHeader && (
      <Draggable onStart={handleStart} onStop={handleStop}>
        <Box
          position={"absolute"}
          bgImage={`url('${COMMON_WEB_PATH}/FlyDragon/titleBG5.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100%100%"
          left={"0px"}
          top={"0px"}
          minW={"48px"}
          h={"52px"}
          rounded={"5px"}
          gap={"10px"}
          alignItems={"center"}
          justifyContent={"center"}
          cursor="pointer"
          className={`!flex`}
          zIndex={999999}
          sx={{
            "& > *": {
              color: "text-yellow-500",
            },
          }}
        >
          {" "}
          <IoIosArrowForward className="text-2xl" />
        </Box>
      </Draggable>
    )
  );
};

export default PCToolTab;
